import React from "react";
import { Card, Skeleton } from "antd";
import "./CardSkeleton.css";

const CardSkeleton = ({ data, classname }) => {
  const skeletonData = Array.from({ length: data });

  return (
    <div
      className={`${
        !classname ? "skeleton-grid-container" : "skeleton-normal-container"
      } `}
    >
      {skeletonData.map((_, index) => (
        <Card key={index} className="card-skeleton-div skeleton-grid-item">
          <Skeleton loading={true} avatar active paragraph={{ rows: 3 }}>
            <Card.Meta title="Card Title" description="Card description" />
          </Skeleton>
        </Card>
      ))}
    </div>
  );
};

export default CardSkeleton;
